import {IsEmptyString} from './common.func';
import {
  JANGDAN,
  JANGDAN_TXT_MAP, MAIN_JASO_LIST,
  POOMSA, POOMSA_DISP_LISP,
  POOMSA_SYMBOL_MAP,
  SASEUNG,
  SASEUNG_DISP_LIST,
  SASEUNG_SYMBOL_MAP,
  SEUNGJO_INVALID,
  SEUNGJO_STEP
} from './gukeo.const';
import {SearchParam} from './client.const';


export function GetPoomSa(txt: string): Array<POOMSA> | null{
  txt = txt.trim();
  if (IsEmptyString(txt)) {
    return null;
  }

  const result = new Array<POOMSA>();
  Array.from(txt).forEach(c => {
    const poomsa = POOMSA_SYMBOL_MAP.get(c.toUpperCase());
    if (poomsa) {
      result.push(poomsa);
    } else {
      console.error(`char[${c}] is not POOMSA char`);
      result.push(POOMSA.NONE);
    }
  });
  return result;
}

export function GetSaSeung(txt: string): Array<SASEUNG> | null {
  txt = txt.trim();
  if (IsEmptyString(txt)) {
    return null;
  }

  const result = new Array<SASEUNG>();
  Array.from(txt).forEach(c => {
    const saseung = SASEUNG_SYMBOL_MAP.get(c.toUpperCase());
    if (saseung) {
      result.push(saseung);
    } else {
      console.error(`char[${c}] is not SEUNGJO char`);
      result.push(SASEUNG.NONE);
    }
  });
  return result;
}

export function GetSaseungTxt(symbol: string): string | null {
  const idx = SASEUNG_SYMBOL_MAP.get(symbol);
  return idx ? SASEUNG_DISP_LIST[idx] : null;
}

/**
 * four_tones 문자열(예: "PSG")을 한글 사성 배열(예: ["평", "상", "거"])로 변환
 * @param fourTones - P, S, G, I 문자들로 이루어진 문자열
 * @returns 한글 사성 배열 (알 수 없는 문자는 제외됨)
 */
export function GetFourTonesArray(fourTones: string): string[] {
  if (!fourTones) return [];
  return fourTones
    .split('')
    .map(symbol => GetSaseungTxt(symbol))
    .filter((txt): txt is string => txt !== null)
    .map(txt => txt + '성');
}

export function GetJangDan(txt: string): Array<JANGDAN> | null {
  txt = txt.trim();
  if (IsEmptyString(txt)) {
    return null;
  }

  const result = new Array<JANGDAN>();
  Array.from(txt).forEach(c => {
    const jangdan = JANGDAN_TXT_MAP.get(c);
    result.push(jangdan ? jangdan : JANGDAN.NONE);
  });
  return result;
}

export function IsJangDanChar(c: string): boolean {
  return !!JANGDAN_TXT_MAP.get(c);
}


export function IsValidSeungJo(seungjo: number): boolean {
  return 0 < seungjo && seungjo <= SEUNGJO_STEP;
}

export function GetSeungJo(txt: string): Array<number> | null {
  txt = txt.trim();
  if (IsEmptyString(txt)) {
    return null;
  }

  const result = new Array<number>();
  Array.from(txt).forEach(c => {
    const seungjo = parseInt(c, 10);
    if (seungjo && 0 < seungjo && seungjo <= SEUNGJO_STEP) {
      result.push(seungjo);
    } else {
      console.error(`char[${c}] is not SEUNGJO char`);
      result.push(SEUNGJO_INVALID);
    }
  });
  return result;
}


// tslint:disable-next-line:variable-name
export function GetHanjaHun(hanja_hun: string): Array<string> {
  return String(hanja_hun).replace(/-/gi, ' ')
    .split('|');
}


export function GetPoomsaTxt(poomsa: POOMSA): string {
  return POOMSA_DISP_LISP[poomsa];
}

export function hunBody(hun: string): string {
  return hun.slice(0, -1);
}
export function hunChar(hun: string): string {
  return hun.slice(-1);
}


const regexArrow = new RegExp("^([→↔ ]+)([^→↔]+)");

export function splitCorrect(correct: string): [string, string] {
  const match = regexArrow.exec(correct);
  if (match) {
    const arrow = match[1]?.trim();
    const word = match[2]?.trim();
    return [arrow, word];
  }
  return ['', ''];
}


const regexHomonym = new RegExp("^([가-힣]+)");

/**
 * 단어id를 넣으면 이운이의어 명(ID)를 반환한다.
 * 예) '가다1' -> '가다'
 *
 * @param word_id
 * @constructor
 */
export function GetHomonymName(word_id: string): string {
    const match = regexHomonym.exec(word_id);
    if (match) {
        return match[1];
    }
    throw new Error(`word_id[${word_id}] format error`);
}


const regexHangul = /^[가-힣]$/;

/**
 * 한글(가-힣) 문자인지 확인하는 함수
 * @param char - 확인하려는 1글자 문자열 (null/undefined 허용)
 */
export function IsHangul(char: string | null | undefined): boolean {
  return !!char && char.length === 1 && regexHangul.test(char);
}
